// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host * {
  text-transform: none; /*anders TOP5 en BEER EVENTS met hoofdletters, is niet (meer) nodig*/
}
:host .square_wide_not_used {
  width: 100%;
  margin-left: 0;
  min-height: 2em;
  --border-radius: 0;
}
:host .square_wide_not_used .content-wrapper {
  display: flex;
  width: 100%;
  justify-content: flex-start; /* Moves content to the left */
  align-items: center;
}
:host .list-number {
  font-weight: bold;
  font-size: 1.2em;
  padding-left: 10px;
  padding-right: 10px;
}
:host .beer-name {
  padding-left: 2px;
  font-size: 1.1em; /*1em;*/
}
:host .brewery-name {
  padding-left: 2px;
  font-size: 14px; /*0.8em;*/
}
:host .button-subtext {
  font-weight: lighter;
  text-transform: none;
  padding-left: 5px;
}
:host .button-inner {
  justify-content: flex-start;
}
:host img {
  max-width: 72px;
  max-height: 54px;
  width: auto;
  height: auto;
  display: block;
  margin: auto;
  /*background: url(http://goo.gl/vyAs27) no-repeat scroll 0 0;*/
}
:host .label-ios, :host .label-md {
  margin: 5px 8px 5px 0;
}
:host .bold_title {
  font-weight: bold;
  color: var(--ion-color-secondary);
}
:host smile-rate {
  margin-top: 50px;
  margin-bottom: 50px;
}
:host ion-item.item-ios {
  padding-left: 0px;
  min-height: 70px;
}
:host ion-item.item-md {
  padding-left: 0px;
  min-height: 70px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
